import { Modal } from "react-bootstrap-v5"
import { ErrorData } from "../models/error-center-model"
import moment from "moment"
import { useCallback, useState } from "react"
import { CustomAlert, IAlert } from "../../../shared/components/CustomAlert"
import { resendToXero } from "../api"
import { resolveMessage } from "../../../shared/service/utils"

interface IProps {
    show: boolean
    errorData: ErrorData | null
    handleClose: () => void
}

const ErrorTypeDiv: React.FC<{ error?: string }> = ({ error }) => {
    const normalizedErrorType = error?.toLowerCase()
    const badgeClass = normalizedErrorType?.includes('mapping')
        ? 'badge-light-danger'
        : normalizedErrorType?.includes('api')
            ? 'badge-light-warning'
            : 'badge-light-info'

    return (
        <td>
            <span className={`badge ${badgeClass}`}>{normalizedErrorType}</span>
        </td>
    )
}

const ErrorDetailsModal: React.FC<IProps> = ({ show, errorData, handleClose }) => {
    const [retrying, setRetrying] = useState(false);
    const [formNotification, setformNotification] = useState<IAlert | undefined>();

    const showNotification = useCallback((notification: IAlert) => {
        setformNotification(notification);
        setTimeout(() => setformNotification(undefined), 3000);
    }, []);

    const handleResend = () => {
        if (errorData) {
            setRetrying(true);

            resendToXero(errorData.id)
                .then(() => {
                    showNotification({
                        message: "Successfully re-send error invoice to Xero",
                        header: `Success re-send`,
                        type: 'success',
                    })
                })
                .catch((error: any) => {
                    showNotification({
                        message: resolveMessage(error, "Internal Server Error"),
                        header: "Re-send failed",
                        type: 'danger'
                    });
                })
                .finally(() => {
                    setRetrying(false)
                });
        }
    }

    return (
        <Modal show={show} onHide={handleClose} size='lg'>
            <Modal.Header>
                <Modal.Title>Error Details</Modal.Title> :
                <button type='button' className='btn-close' onClick={handleClose}></button>
            </Modal.Header>
            <Modal.Body>
                {formNotification && <CustomAlert {...formNotification} />}
                <div className='col-6'>
                    <div className='fw-bold text-gray-800'>Invoice</div>
                    <div className='fw-bolder fs-5'>{errorData?.invoiceNumber}</div>
                    <div className='fw-bold text-gray-800'>{errorData?.invoicedName}</div>
                </div>

                <div className='row align-items-center pe-2 mt-5'>
                    <div className='col-6'>
                        <div className='fw-bold text-gray-800'>Error Type</div>
                        <ErrorTypeDiv error={errorData?.xeroSendErrorType} />
                    </div>
                    <div className='col-6'>
                        <div className='fw-bold text-gray-800'>Attempts</div>
                        <div className='fw-bold fs-5'>{errorData?.xeroSendAttemptCount}</div>
                    </div>
                </div>

                <div className='col-12  mt-5'>
                    <div className='fw-bold text-gray-800'>Error Message</div>
                    <div className='alert alert-danger'>{errorData?.xeroSendErrorMessage}</div>
                </div>

                <div className='col-12  mt-5'>
                    <div className='fw-bold text-gray-800'>Raw Error</div>
                    <div className='alert alert-light'>{errorData?.xeroSendError}</div>
                </div>

                <div className='row align-items-center pe-2 mt-5'>
                    <div className='col-6'>
                        <div className='fw-bold text-gray-800'>First Occurrence</div>
                        <div className='fw-bold fs-5'>{moment(errorData?.xeroFirstSendError).format("DD/MM/YYYY, h:mm:ss a")}</div>
                    </div>
                    <div className='col-6'>
                        <div className='fw-bold text-gray-800'>Last Attempt</div>
                        <div className='fw-bold fs-5'>{moment(errorData?.xeroLastAttemptAtUtc).format("DD/MM/YYYY, h:mm:ss a")}</div>
                    </div>
                </div>

                <div className='row align-items-center mt-6 pe-2'>
                    <div className='col-6'>
                    </div>
                    <div className='col-6 d-flex justify-content-end'>
                        <button type='button' className='btn btn-secondary mt-8 mx-3' onClick={handleClose} >
                            Cancel
                        </button>
                        <button type='submit' className='btn btn-primary mt-8' onClick={handleResend}>
                            {!retrying && <span className='indicator-label'><i className="fas fa-redo"></i> Retry Transfer </span>}
                            {retrying && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Retrying Transfer
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export { ErrorDetailsModal };